import { useCallback } from 'react';
import Cookies from 'js-cookie';

const ONE_HOUR_MS = 1000 * 60 * 60;

export const useCookie = (cookieName) => {
	// Set the cookie, expiring in 1 hour.
	const setCookie = useCallback(
		(value) => {
			Cookies.set(cookieName, value, {
				expires: new Date(Date.now() + ONE_HOUR_MS),
				path: '/',
			});
		},
		[cookieName]
	);

	// Remove the cookie immediately.

	const removeCookie = useCallback(() => {
		Cookies.remove(cookieName, { path: '/' });
	}, [cookieName]);

	// Read the current value of the cookie (or undefined if not set).
	const getCookie = useCallback(() => {
		return Cookies.get(cookieName);
	}, [cookieName]);

	return { setCookie, removeCookie, getCookie };
};
